// src/validation-rules.js
import { defineRule } from 'vee-validate';
import { required } from '@vee-validate/rules';

// For required text fields and select elements
defineRule('required', value => required(value) ? true : 'This field is required');


// For all numeric input fields
defineRule('number', value => {
  if (value === '' || value === null || value === undefined) return true;
  return !isNaN(Number(value)) || 'Must be a number';
});

// For location depth, exact mass, UV values and Log Ɛ
defineRule('non_negative', value => {
  if (value === '' || value === null || value === undefined) return true;
  return Number(value) >= 0 || 'Must be non-negative';
});

// For latitude and longitude
defineRule('min_max', (value, [min, max]) => {
  if (value === '' || value === null || value === undefined) return true;

  const n = Number(value);
  min = Number(min);
  max = Number(max);

  if (isNaN(n)) return 'Must be a number';

  return (n >= min && n <= max) || `Must be from ${min} to ${max}`;
});

// For DOI
defineRule('doi', value => {
  if (!value) return true;
  return value.startsWith('10.') || 'Must start with 10.';
});

defineRule('inchi', value => {
  if (!value) return true;
  return value.startsWith('InChI=') || 'Must start with InChI=';
});

// For InChIKey
defineRule('inchikey', value => {
  if (!value) return true;
  const valid = value.length === 27 &&
                value[14] === '-' &&
                value[25] === '-' &&
                /^[A-Z-]*$/.test(value);
                                 // Regex Fragment      | Meaning
                                 // ========================================
                                 // ^       $           | Start and end of string
                                 //  [A-Z-]*            | All characters are A-Z or dashes
  return valid ? true : 'Must be 27 characters long (A-Z and dashes only)';
});

// For MarinLit (Article) ID
defineRule('articleId', value => {
  if (!value) return true;
                                 // Regex Fragment      | Meaning
                                 // ========================================
                                 // ^         $         | Start and end of string
                                 //  [A]                | First character is 'A'
                                 //     [0-9]*          | Any subsequent characters are numbers
  const valid = /^[A][0-9]+$/.test(value) && value.length > 1;
  return valid ? true : "Must be 'A' followed by a number";
});

// For Compound MarinLit ID
defineRule('compoundMarinLitId', value => {
  if (!value) return true;
                                 // Regex Fragment      | Meaning
                                 // ========================================
                                 // ^         $         | Start and end of string
                                 //  [L]                | First character is 'L'
                                 //     [0-9]*          | Any subsequent characters are numbers
  const valid = /^[L][0-9]+$/.test(value) && value.length > 1;
  return valid ? true : "Must be 'L' followed by a number";
});
